import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_EYE_CLOSED: GlameraIconDefinition = {
  name: 'eye-closed',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-eye-closed-group">
      <path
        class="glm-eye-closed-arc"
        pathLength="1"
        d="M2 8a10.645 10.645 0 0 0 20 0">
      </path>
      <path class="glm-eye-closed-lash glm-eye-closed-lash-0" d="m15 18-.722-3.25"></path>
      <path class="glm-eye-closed-lash glm-eye-closed-lash-1" d="m9 18 .722-3.25"></path>
      <path class="glm-eye-closed-lash glm-eye-closed-lash-2" d="m20 15-1.726-2.05"></path>
      <path class="glm-eye-closed-lash glm-eye-closed-lash-3" d="m4 15 1.726-2.05"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-eye-closed-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './eye-closed.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class EyeClosedIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_EYE_CLOSED;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
